import { canv } from '@/canv/global.js'
import { randomIntFromInterval } from '@/canv/utils.js';

let DRAW_ERROR_LOGGED = false;

export class emoteVis {

    constructor(startX, startY, url, canvas = null) {

        this.canvas = canvas;
        this.baseX = startX;
        this.baseY = startY;
        this.startX = startX;
        this.startY = startY;
        this.opacity = 1;

        const dpr = canv.dpr;
        const m0 = canvas ? canvas.getContext('2d').getTransform().a : canv.m[0];

        const sizeMin = 25;
        const sizeMax = 50;
        this.size = randomIntFromInterval(sizeMin / m0 * dpr, sizeMax / m0 * dpr);

        const velocityYMin = 6;
        const velocityYMax = 9;
        this.velocityY = randomIntFromInterval(velocityYMin / m0 * dpr, velocityYMax / m0 * dpr);

        const randomer = randomIntFromInterval(-1, 1);
        this.velocityX = randomer < 0 ? -5 / m0 * dpr : 5 / m0 * dpr;

        const radiusMin = 30;
        const radiusMax = 60;
        this.radius = randomIntFromInterval(radiusMin / m0 * dpr, radiusMax / m0 * dpr);

        const lengthMin = 250;
        const lengthMax = 400;
        this.length = randomIntFromInterval(lengthMin / m0 * dpr, lengthMax / m0 * dpr);


        const img = new Image();
        img.src = url;
        img.onload = this.imageOnLoad.bind(this, img);
    }

    imageOnLoad(img) {
        this.image = img;
    }

    draw() {
        if (!this.image) return; // image isn't to loaded

        const ctx = this.canvas ? this.canvas.getContext('2d') : canv.ctx;
        try {
            ctx.globalAlpha = this.opacity;
            ctx.drawImage(this.image, this.startX, this.startY, this.size, this.size);
        } catch (e) {
            console.error(e);
            if (!DRAW_ERROR_LOGGED) {
                DRAW_ERROR_LOGGED = true;
                canv.captureException(e);
            }
        }
        ctx.globalAlpha = 1;
    }

    step() {
        const lengthKoef = (this.length - Math.abs(this.baseY - this.startY)) / (this.length);
        this.startY -= this.easeOutBack(lengthKoef) * this.velocityY;
        this.opacity = this.easeOutBack(lengthKoef);

        const koef = (this.radius - Math.abs(this.startX - this.baseX)) / (this.radius);
        this.startX += this.easeOutBack(lengthKoef) * this.easeOutCubic(koef) * this.velocityX; // easeOutCubic

        if (this.startX < this.baseX - this.radius + 5 && this.velocityX < 0 || this.startX > this.baseX + this.radius - 5 && this.velocityX > 0) {
            this.velocityX *= -1;
        }

        if (this.baseY - this.startY > this.length - 2) {
            this.finished = true;
        }
    }

    easeOutCubic(x) {
        return 1 - Math.pow(1 - x, 3);
    }

    easeInOutBack(x) {
        const c1 = 1.70158;
        const c2 = c1 * 1.525;

        return x < 0.5
          ? (Math.pow(2 * x, 2) * ((c2 + 1) * 2 * x - c2)) / 2
          : (Math.pow(2 * x - 2, 2) * ((c2 + 1) * (x * 2 - 2) + c2) + 2) / 2;
    }

    easeInOutExpo(x) {
        return x === 0
          ? 0
          : x === 1
          ? 1
          : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2
          : (2 - Math.pow(2, -20 * x + 10)) / 2;
    }

    easeOutBack(x) {
        const c1 = 1.70158;
        const c3 = c1 + 1;

        return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2);
    }

    easeInOutCubic(x) {
        return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
    }

    easeInOutQuad(x) {
        return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
    }

    easeOutQuad(x) {
        return 1 - (1 - x) * (1 - x);
    }

    easeOutQuint(x) {
        return 1 - Math.pow(1 - x, 5);
    }

    easeOutExpo(x) {
        return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
    }

    name = "emote";
    finished = false;
    startX = 0;
    startY = 0;
    size = 0;
    velocity = 0;
    opacity = 1;
    canvas = null;
}
